import Logo from "components/general/logo";
import styled, { keyframes } from "styled-components";

const StyledWrapper = styled.div`
  height: 100%;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  padding: 1rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h1 {
    text-align: center;
    max-width: 600px;
    line-height: 4rem;
    font-size: 3.375rem;
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
  }
  img {
    flex: 0 0 100px;
  }
`;
const animationRedact = keyframes`
0% {
  transform: translate(-50%, -50%) rotate(0deg);
}
100% {
  transform: translate(-50%, -50%) rotate(360deg);
}
`;

const LoaderParent = styled.div`
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
`;
const LoaderChild = styled.div`
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
  padding: 100px;
`;
const LoaderInner = styled.div`
  box-sizing: content-box;
  animation: ${animationRedact} 1s linear infinite;
  position: absolute;
  width: 40px;
  height: 40px;
  border: 10px solid #6c8ef8;
  border-top-color: transparent;
  border-radius: 50%;
`;

const Loader = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <Logo size="h-[3.5rem]" />
        <LoaderParent>
          <LoaderChild>
            <LoaderInner />
          </LoaderChild>
        </LoaderParent>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Loader;
